<template>
  <div>
    <b-container>
      <div>
        <b-modal v-model="modalShow">{{ messagge }}</b-modal>
      </div>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(next)" autocomplete="off">
          <b-card>
            <template #header>
              <h6 class="mb-0">BENEFICIARIOS DEL SEGURO DE VIDA / MYDA</h6>
            </template>
            <h5>Beneficiario</h5>
            <p class="text-muted small mb-2">
              Los designados por el asegurado o en su defecto beneficiarios de ley.
              La suma de los porcentajes debe ser 100%.
            </p>
            <div class="table-responsive">
              <table class="table-one">
                <thead>
                  <tr>
                    <th>Nombre(s)</th>
                    <th>Apellido(s)</th>
                    <th>Tipo Doc</th>
                    <th>Nro. Identificación</th>
                    <th>Fecha Nac.</th>
                    <th>Parentesco</th>
                    <th>Sexo</th>
                    <th>%</th>
                    <th style="width: 70px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in form.beneficiarios" v-bind:key="index">
                    <td style="display: none">
                      <span>Beneficiario {{ index + 1 }}</span>
                    </td>
                    <td style="width: 14%">
                      <b-form-input type="text" v-model="item.name" :state="getValidationName(index)"></b-form-input>
                    </td>
                    <td style="width: 14%">
                      <b-form-input type="text" v-model="item.lastName"
                        :state="getValidationLastName(index)"></b-form-input>
                    </td>
                    <td style="width: 10%">
                      <b-form-select v-model="item.documentType" :options="control.docTypeOptions"
                        :state="getValidationDocumentType(index)"></b-form-select>
                    </td>
                    <td style="width: 12%">
                      <b-form-input type="text" v-model="item.document"
                        :state="getValidationDocument(index)"></b-form-input>
                    </td>
                    <td style="width: 11%">
                      <b-form-input type="date" v-model="item.birthDay"
                        :state="getValidationBirthDay(index)"></b-form-input>
                    </td>
                    <td style="width: 12%">
                      <b-form-select v-model="item.relation" :options="control.TIPOS_BENEFICIARIOS"
                        :state="getValidationRelation(index)"></b-form-select>
                    </td>
                    <td style="width: 8%">
                      <b-form-select v-model="item.sex" :options="control.TIPOS_SEXO"
                        :state="getValidationSex(index)"></b-form-select>
                    </td>
                    <td style="width: 8%">
                      <validation-provider name="label">
                        <b-form-input type="number" min="0" max="100" step="0.01" v-model="item.percentage"
                          :state="getValidationPercentage(index)"></b-form-input>
                      </validation-provider>
                    </td>
                    <td style="width: 5%">
                      <b-btn v-if="!rowEmpty(index)" pill variant="outline-danger"
                        @click="limpiar(index)">Borrar</b-btn>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p v-if="totalPercentage !== 100 && totalPercentage > 0" class="text-danger small">
              Suma de porcentajes: {{ totalPercentage }}%. Debe ser 100%.
            </p>

            <b-row align-h="end" class="mt-4">
              <b-col md="4" cols="4" style="display: flex; justify-content: flex-end">
                <b-button @click="previous" variant="secondary">Anterior</b-button>
                <b-button type="submit" variant="primary">Siguiente</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
import { TIPOS_IDENTIFICACIONES, TIPOS_BENEFICIARIOS, TIPOS_SEXO } from "@/data/colombia/vida/Selects"; 

export default {
  name: "FormColombia02",
  components: {},
  data: function () {
    return {
      messagge: "",
      control: {
        docTypeOptions: [{ value: null, text: "Seleccione" }, ...TIPOS_IDENTIFICACIONES],
        TIPOS_BENEFICIARIOS,
        TIPOS_SEXO,
      },
      form: {},
      modalShow: false,
    };
  },
  computed: {
    totalPercentage() {
      if (!this.form.beneficiarios) return 0;
      return this.form.beneficiarios.reduce(
        (sum, b) => sum + (Number(b.percentage) || 0),
        0
      );
    },
  },
  mounted: function () {
    this.$store.dispatch("app/loading", true);
    const { form } = this.$store.state.wizard;
    if (form === undefined || form === null || form === "") {
      this.$router.push("/form/colombia/vida/");
    }
    this.form = form;
    if (!this.form.beneficiarios || this.form.beneficiarios.length === 0) {
      const vacio = {
        name: "",
        lastName: "",
        documentType: "",
        document: "",
        birthDay: "",
        relation: "",
        sex: "",
        percentage: ""
      };

      this.form.beneficiarios = [{ ...vacio }, { ...vacio }];
    }
    this.$store.dispatch("app/loading", false);
  },
  methods: {
    previous() {
      const form = { ...this.form };

      this.$store
        .dispatch("wizard/save", { index: 1, form })
        .then(this.$router.push("/form/colombia-vida-1.html"));  
    },
    next() {
      const form = { ...this.form };

      if (this.tableEmpty()) {
        this.$bvToast.toast("Por favor cargue al menos un beneficiario", {
          title: "Información incompleta",
          variant: "danger",
          solid: true,
        });
        return false;
      }
      if (this.totalPercentage !== 100) {
        this.$bvToast.toast("La suma de los porcentajes debe ser 100%.", {
          title: "Validación",
          variant: "danger",
          solid: true,
        });
        return false;
      }
      if (this.validation()) {
        this.$store
          .dispatch("wizard/save", { index: 2, form })
          .then(this.$router.push("/form/colombia-vida-3.html"));  
      } else {
        this.$bvToast.toast("Por favor controle la información cargada en beneficiarios", {
          title: "Información incompleta",
          variant: "danger",
          solid: true,
        });
      }
    },
    validation() {
      let ok = true;
      for (let i = 0; i < this.form.beneficiarios.length; i++) {
        if (!this.rowEmpty(i))
          ok =
            ok &&
            this.getValidationName(i) &&
            this.getValidationLastName(i) &&
            this.getValidationDocumentType(i) &&
            this.getValidationDocument(i) &&
            this.getValidationBirthDay(i) &&
            this.getValidationRelation(i) &&
            this.getValidationSex(i) &&
            this.getValidationPercentage(i);
      }
      return ok;
    },

    tableEmpty() {
      for (let i = 0; i < this.form.beneficiarios.length; i++) {
        if (!this.rowEmpty(i)) {
          return false;
        }
      }
      return true;
    },

    rowEmpty(index) {
      return (
        this.form.beneficiarios[index].name == "" &&
        this.form.beneficiarios[index].lastName == "" &&
        this.form.beneficiarios[index].documentType == "" &&
        this.form.beneficiarios[index].document == "" &&
        this.form.beneficiarios[index].birthDay == "" &&
        this.form.beneficiarios[index].relation == "" &&
        !this.form.beneficiarios[index].sex &&
        this.form.beneficiarios[index].percentage == ""
      );
    },
    limpiar(index) {
      this.form.beneficiarios[index].name = "";
      this.form.beneficiarios[index].lastName = "";
      this.form.beneficiarios[index].documentType = "";
      this.form.beneficiarios[index].document = "";
      this.form.beneficiarios[index].birthDay = "";
      this.form.beneficiarios[index].relation = "";
      this.form.beneficiarios[index].sex = "";
      this.form.beneficiarios[index].percentage = "";
    },
    getValidationName(index) {
      const state = this.rowEmpty(index) || this.form.beneficiarios[index].name != "";

      if (state && this.form.beneficiarios[index].name == "") {
        return null;
      } else {
        return state;
      }
    },
    getValidationLastName(index) {
      const state = this.rowEmpty(index) || this.form.beneficiarios[index].lastName != "";

      if (state && this.form.beneficiarios[index].lastName == "") {
        return null;
      } else {
        return state;
      }
    },
    getValidationDocumentType(index) {
      const state = this.rowEmpty(index) || this.form.beneficiarios[index].documentType != "";

      if (state && this.form.beneficiarios[index].documentType == "") {
        return null;
      } else {
        return state;
      }
    },
    getValidationDocument(index) {
      const state = this.rowEmpty(index) || this.form.beneficiarios[index].document != "";

      if (state && this.form.beneficiarios[index].document == "") {
        return null;
      } else {
        return state;
      }
    },
    getValidationBirthDay(index) {
      const state = this.rowEmpty(index) || this.form.beneficiarios[index].birthDay != "";

      if (state && this.form.beneficiarios[index].birthDay == "") {
        return null;
      } else {
        return state;
      }
    },
    getValidationRelation(index) {
      const state = this.rowEmpty(index) || this.form.beneficiarios[index].relation != "";

      if (state && this.form.beneficiarios[index].relation == "") {
        return null;
      } else {
        return state;
      }
    },
    getValidationSex(index) {
      const state = this.rowEmpty(index) || this.form.beneficiarios[index].sex != "";

      if (state && this.form.beneficiarios[index].sex == "") {
        return null;
      } else {
        return state;
      }
    },
    getValidationPercentage(index) {
      const valor = Number(this.form.beneficiarios[index].percentage);

      const state = this.rowEmpty(index) || (valor >= 0 && valor <= 100);

      if (state && this.form.beneficiarios[index].percentage == "") {
        return null;
      } else {
        return state && this.totalPercentage == 100;
      }
    },
  },
};
</script>

<style scoped>
img.preview {
  width: 500px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
}

.photo-preview {
  width: 150px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
}

.fz16 {
  font-size: 16px;
}

.w100 {
  width: 100%;
}

.fr {
  float: right;
}

.furnituresContainer {
  border-bottom: 1px solid #ced4da;
}

.container {
  max-width: 100% !important;
}

#input-BirthDay {
  margin-left: 3px;
}

.td-button {
  width: 80px;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
}

/* RESPONSIVE */

@media only screen and (max-width: 1000px) {
  .navbar-brand a {
    width: 200px !important;
    display: none;
  }

  table,
  thead,
  tbody,
  th,
  td,
  tr,
  .button {
    display: block;
    position: relative;
  }

  thead,
  tbody {
    text-align: start;
  }

  thead tr {
    display: none;
  }

  tr {
    margin-bottom: 40px;
  }

  td {
    border-bottom: 1px solid #eee;
    position: relative;
    width: 100% !important;
  }

  td:has(input, select) {
    padding-top: 30px;
  }

  td:has(button) {
    padding-top: 10px;
    text-align: right;
  }

  td:before {
    position: absolute;
    top: 3px;
    left: 6px;
    padding-right: 10px;
    white-space: nowrap;
    font-weight: bold;
  }

  td:nth-of-type(1) {
    display: block !important;
    border-bottom: 2px solid var(--primary);
    margin-bottom: 20px;
  }

  td:nth-of-type(2):before {
    content: "Nombre(s)";
  }

  td:nth-of-type(3):before {
    content: "Apellido(s)";
  }

  td:nth-of-type(4):before {
    content: "Tipo Doc";
  }

  td:nth-of-type(5):before {
    content: "Nro. Identificación";
  }

  td:nth-of-type(6):before {
    content: "Fecha Nac.";
  }

  td:nth-of-type(7):before {
    content: "Parentesco";
  }

  td:nth-of-type(8):before {
    content: "Porcentaje";
  }
}
</style>
